import type { ReactNode } from 'react';
import CornerIcon from '@public/assets/sport/icons/corner.svg';
import OvertimeIcon from '@public/assets/sport/icons/overtime.svg';
import PenaltyIcon from '@public/assets/sport/icons/penalty.svg';
import RedCardIcon from '@public/assets/sport/icons/redCard.svg';
import YellowCardIcon from '@public/assets/sport/icons/yellowCard.svg';
export const gameEventIcons: Dictionary<ReactNode> = {
  penalty: <PenaltyIcon width={16} height={16} />,
  overtime: <OvertimeIcon width={16} height={16} />,
  CORNER: <CornerIcon width={16} height={16} />,
  YELLOW_CARD: <YellowCardIcon width={16} height={16} />,
  RED_CARD: <RedCardIcon width={16} height={16} />
};